// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    PRODUCT_INDEX_SECTION_PAGE_LOADING() {
      return {
        isLoading: true,
        productIndexSectionPage: action.productIndexSectionPage
      };
    },
    PRODUCT_INDEX_SECTION_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.productIndexSectionPage
      };
    },
    PRODUCT_INDEX_SECTION_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.productIndexSectionPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
